import a, { keyframes as s, css as d } from "styled-components";
import { Base as r } from "./atoms-v2777.js";
import { Button as t } from "./atoms-v26.js";
import { Text as p } from "./atoms-v243.js";
const l = s`
  from { opacity: 0; }
  to { opacity: 1; }
`, u = a.div`
  ${r}

  animation-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")};
  animation-name: ${l};
  animation-timing-function: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.entrance")};
  background-color: ${({ $colorTheme: o, theme: i }) => {
  var n;
  return (n = i == null ? void 0 : i.get) == null ? void 0 : n.call(i, `tokens.surface.${o}.background`);
}};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.modalRadius")}px;
  box-shadow: 0 8px 20px 2px rgb(0 0 0/0.28);
  color: ${({ $colorTheme: o, theme: i }) => {
  var n;
  return (n = i == null ? void 0 : i.get) == null ? void 0 : n.call(i, `tokens.text.${o}.primary`);
}};
  display: flex;
  flex-direction: column;
  z-index: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.zindex.dialog")};

  ${({ $size: o }) => o === "default" && d`
      width: 640px;
    `}

  ${({ $size: o }) => o === "small" && d`
      width: 480px;
    `}

  ${({ $size: o }) => o === "mobile" && d`
      width: 320px;
    `}
`, $ = a.header`
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: space-between;
  padding: 16px 14px;
`, y = a.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`, b = a.div`
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}}

  flex: 1;
  padding: 0 16px 24px;
  text-wrap: pretty;
`;
a.footer`
  align-items: center;
  display: flex;
  gap: ${({ $size: o }) => o === "default" ? 8 : 16}px;
  justify-content: space-between;
  padding: 16px ${({ $size: o }) => o === "default" ? 24 : 16}px;
  width: 100%;
`;
const k = a.div`
  ${({ $size: o, theme: i }) => {
  var n;
  return o === "default" || o === "small" && ((n = i == null ? void 0 : i.get("tokens.heading.03")) == null ? void 0 : n.toJS());
}}
  ${({ $size: o, theme: i }) => {
  var n;
  return o === "mobile" && ((n = i == null ? void 0 : i.get("tokens.body.expressive")) == null ? void 0 : n.toJS());
}}

  flex-grow: 1;
`, v = a.div`
  text-align: right;
`;
a.div`
  flex-basis: 50%;
`;
a.div`
  flex-basis: 50%;
`;
const w = a(t)`
  height: 44px;
  width: 44px;
`, S = a(p)`
  color: ${({ $colorTheme: o, theme: i }) => {
  var n;
  return (n = i == null ? void 0 : i.get) == null ? void 0 : n.call(i, `tokens.text.${o}.secondary`);
}};

  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : i.toJS();
}}
`;
export {
  u as AnchoredDialog,
  b as Body,
  v as Close,
  w as CloseButton,
  $ as Header,
  S as HeaderLabel,
  y as HeaderLeft,
  k as Heading
};
